import { jsx as _jsx } from "react/jsx-runtime";
import { useOverlayContext, ConfirmationModal } from 'seagull';
import { useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { handlePromise } from '~/infra/utils';
const removeLoader = 'dcPM';
export function useDisconnectPaymentMethod() {
    const { api, logBI } = useStoreActions();
    const overlayContext = useOverlayContext();
    const { t: commonTexts } = useLocaleKeys('common');
    const { t: texts } = useLocaleKeys('hooks.disconnectPaymentMethod');
    return async function disconnectPaymentMethod(param) {
        let { relationshipId, isCreditCard, last4, onSuccess, performDisconnect } = param;
        const confirmed = await overlayContext.showModal({
            biName: 'disconnect_payment_method_confirm',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ConfirmationModal, {
                    bi: {
                        primaryButton: {
                            name: 'use_disconnect_payment_method_confirm'
                        },
                        secondaryButton: {
                            name: 'use_disconnect_payment_method_cancel'
                        }
                    },
                    textAlignCenter: false,
                    title: isCreditCard ? last4 ? texts.titleCreditCard({
                        last4
                    }) : texts.titleCreditCardNoLast4() : last4 ? texts.titleBankAccount({
                        last4
                    }) : texts.titleBankAccountNoLast4(),
                    content: texts.content(),
                    skin: "danger",
                    primaryButtonLabel: commonTexts.buttons.disconnect(),
                    primaryButtonTestId: "disconnect-pm-confirm",
                    secondaryButtonLabel: commonTexts.buttons.cancel(),
                    onPrimaryButtonClick: ()=>dismissModal(true),
                    onSecondaryButtonClick: ()=>dismissModal(false)
                });
            }
        });
        if (!confirmed) {
            return;
        }
        overlayContext.startLoader(removeLoader);
        const { success } = performDisconnect ? await performDisconnect() : await handlePromise(api.relationship.disconnectPaymentMethod(relationshipId));
        if (!success) {
            overlayContext.showErrorToast(commonTexts.toasts.failedToDisconnectPaymentMethod(), 'disconnect-pm-error');
            return overlayContext.stopLoader(removeLoader);
        }
        logBI(10593, {
            relationshipId
        });
        try {
            await onSuccess();
        } finally{
            overlayContext.stopLoader(removeLoader);
        }
    };
}
